import * as actions from '../actions/index' 
import _ from "lodash"

let initialState = {}

const addNewElement = (fieldName, value) => {
    return {
        PGAId: fieldName,
        dataType: "STRING",
        id: Math.random()+"_"+Math.random(),
        isOptional: "Y",
        isRepeated: "N",
        key: fieldName,
        lengthClass: "2X",
        uiInputType: "DISPLAY",
        uiLabel: "",
        uiLabelDesc: "",
        value: value
    }
}

const productHistPga = (state = initialState, action) => {
    let newFormData = _.cloneDeep(state);
	switch(action.type){
		case actions.INITIATE_PGA_DATA:{
			return action.payload
        }
		case actions.UPDATE_PGA_DATA:{
			let pgaTypeIndex = newFormData.pgaData.pgaActData.findIndex((item) => {
                return item.pgaType == action.formType
            })
            let fieldIndex = newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems.findIndex((item) => {
                return item.PGAId === action.fieldName
            })
            if(fieldIndex == -1){
                let newElem = addNewElement(action.fieldName, action.value);
                newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems.push(newElem);
            }else{
                newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].value = action.value;
                newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].changed = "true";
            }
            return newFormData;
        }
        case actions.UPDATE_REPEATED_SUB_FIELD:{
            // if(containerCardinality < 0){
            //     return updateRepeatedField(pgaGuid, targetPGA, lineItemIndex, index, field, payload, list);
            // }
            let pgaTypeIndex = newFormData.pgaData.pgaActData.findIndex((item) => {
                return item.pgaType == action.targetPGA
            })
            let fieldIndex = newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems.findIndex((item) => {
                return item.key === `${action.field}.${action.containerCardinality + 1}.${action.index + 1}`
                
            })
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].value = action.payload;  
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].changed = "true";
			return newFormData;
        }
        case actions.UPDATE_REPEATED_SUB_SUB_FIELD:{   
            let pgaTypeIndex = newFormData.pgaData.pgaActData.findIndex((item) => {
                return item.pgaType == action.targetPGA
            })
            let fieldIndex = newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems.findIndex((item) => {
                return item.key === `${action.field}.${action.containerCardinality + 1}.${action.innerContainerCardinality + 1}.${action.index + 1}`
                
            })
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].value = action.payload;
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].changed = "true";
            return newFormData;
        }
        case actions.UPDATE_REPEATED_FIELD:{
            let pgaTypeIndex = newFormData.pgaData.pgaActData.findIndex((item) => {
                return item.pgaType == action.targetPGA
            })
            let fieldIndex = newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems.findIndex((item) => {
                return item.key === `${action.field}.${action.index + 1}`
            })
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].value = action.payload;
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].changed = "true";
            return newFormData
        }
        case actions.UPDATE_LACEY_ACT_FIELD:{
            let pgaTypeIndex = newFormData.pgaData.pgaActData.findIndex((item) => {
                return item.pgaType == "LACEY"
            })
            let fieldIndex = newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems.findIndex((item) => {
                return item.key === action.field
            })
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].value = action.payload;
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].changed = "true";
            return newFormData
        }
        case actions.UPDATE_PGA_ITEM_FIELD:{
            let pgaTypeIndex = newFormData.pgaData.pgaActData.findIndex((item) => {
                return item.pgaType == "LACEY"
            })
            let fieldIndex = newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems.findIndex((item) => {
                return item.key === `${action.field}.${action.index + 1}`
            })
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].value = action.payload
            newFormData.pgaData.pgaActData[pgaTypeIndex].PGAItems[fieldIndex].changed = "true";
            return newFormData
        }
		default:  
			return state;
	}
}

export default productHistPga;